import React from 'react';
import { useTranslation } from 'react-i18next';

import GlyphSearch from '@/assets/icons/glyph_search.svg?component';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';
import TextField from '@/components/atoms/TextField';

interface FilterProps {
    filter: string;
    setFilter: (filter: string) => void;
}
export default function Filter<T extends FilterProps>({ filter, setFilter, ...other }: T) {
    const { t } = useTranslation();
    const [value, setValue] = React.useState(filter);

    React.useEffect(() => {
        const handler = setTimeout(() => {
            setFilter(value);
        }, 1000);

        return () => {
            clearTimeout(handler);
        };
    }, [setFilter, value]);

    return (
        <span {...other}>
            <TextField
                suffix={<SvgIcon icon={GlyphSearch} size="custom" customSize={22} />}
                value={value || ''}
                onChange={(e) => setValue(e.target.value)}
                placeholder={t('common.labels.searchText')}
            />
        </span>
    );
}
